const items = [
  "Unhurried Mornings",
  "Crystal Waters",
  "Private Innova Crysta",
  "Sacred Groves",
  "Living Root Bridges",
  "Land of Clouds",
  "South Indian Comforts",
  "4★ Eco-Resorts",
];

export const Marquee = () => {
  const loop = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-ink py-6" data-testid="editorial-marquee">
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 text-2xl md:text-3xl font-display italic text-white/85">
            {item}
            <span className="text-gold not-italic">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
